import { Routes } from "@angular/router"


export const routes: Routes = [
    {
        path: "",
        redirectTo: "/start",
        pathMatch: "full",
    },
    {
        path: "start",
        pathMatch: "full",
        loadComponent: () => import('./pages/start/start.page').then(m => m.StartPage)
    },
    {
        path: "weather", pathMatch: "full",
        loadComponent: () => import('./pages/weather/weather.page').then(m => m.WeatherPage)
    },
    {
        path: "places",
        loadComponent: () => import('./pages/places/places.page').then(m => m.PlacesPage)
    },
    {
        path: "helper",
        loadComponent: () => import('./pages/helper/helper.page').then(m => m.HelperPage)
    },
]